exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n[dir] .p-3[data-v-5aa3391a] {\n  padding: 0.75rem !important;\n}\n", "", {"version":3,"sources":["/var/www/html/layouts/lp_whoapp.vue"],"names":[],"mappings":";AACA;EACE,4BAA4B;CAC7B","file":"lp_whoapp.vue","sourcesContent":["\n[dir] .p-3[data-v-5aa3391a] {\n  padding: 0.75rem !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"minimize":false,"importLoaders":0,"alias":{"/assets":"/var/www/html/assets","/static":"/var/www/html/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5aa3391a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./layouts/lp_whoapp.vue
// module id = ./node_modules/css-loader/index.js?{"sourceMap":true,"minimize":false,"importLoaders":0,"alias":{"/assets":"/var/www/html/assets","/static":"/var/www/html/static"}}!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-5aa3391a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./layouts/lp_whoapp.vue
// module chunks = 16